<h4><u>Quote Details</u></h4>
<div class="row" *ngIf="quoteDetails?.id">
  <div class="col-md-7">
    <div class="row mb-3">
      <div class="col-md-6"><label>Status:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="statusLabel" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Broker:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="brokerName || '—'" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Cover From:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="quoteDetails.policy_start_date | date:'dd/MM/yyyy'" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Cover To:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="quoteDetails.policy_end_date | date:'dd/MM/yyyy'" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>MTA Effective Date:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="quoteDetails.effective_date | date:'dd/MM/yyyy'" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3" *ngIf="showMtaReason">
      <div class="col-md-6"><label>{{ quoteDetails?.transaction_type == 4 ? 'Policy Reason' : 'MTA Reason' }}:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="mtaReasonLabel || '—'" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3" *ngIf="showMtaReason && mtaReasonLabel.toLowerCase() === 'other'">
      <div class="col-md-6"><label>Other Reason:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="mtaReasonOther || '—'" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Product:</label></div>
      <div class="col-md-6">
        <input type="text" value="Equine" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Transaction Type:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="getTransactionTypeLabel()" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3" *ngIf="quoteDetails?.vulnerability_marker_details">
      <div class="col-md-6"><label>Vulnerability Marker:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="!!quoteDetails.vulnerability_marker_details ? 'Yes' : 'No'" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3" *ngIf="quoteDetails?.vulnerability_marker_details">
      <div class="col-md-6"><label>Vulnerability Marker Notes:</label></div>
      <div class="col-md-6">
        <textarea class="form-control form-control-sm" rows="3" readonly>{{ quoteDetails.vulnerability_marker_details }}</textarea>
      </div>
    </div>
  </div>
</div>

<h4 class="mt-4"><u>Proposer Details</u></h4>
<div class="row" *ngIf="quoteDetails?.proposer_details">
  <div class="col-md-7">
    <div class="row mb-3">
      <div class="col-md-6"><label>Title:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="quoteDetails.proposer_details.title" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>First Name:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="quoteDetails.proposer_details.first_name" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Last Name:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="quoteDetails.proposer_details.last_name" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Email:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="quoteDetails.proposer_details.email" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Phone:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="quoteDetails.proposer_details.phone" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3" *ngIf="quoteDetails.proposer_details.dob">
      <div class="col-md-6"><label>Date of Birth:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="quoteDetails.proposer_details.dob | date:'dd/MM/yyyy'" class="form-control form-control-sm" readonly>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-6"><label>Address:</label></div>
      <div class="col-md-6">
        <input type="text" [value]="proposerAddress || '—'" class="form-control form-control-sm" readonly>
      </div>
    </div>
  </div>
</div>



<p *ngIf="!quoteDetails?.id" class="text-muted">No quote data to display.</p>
